import React, { FC, ReactNode, createContext, useContext } from "react";

// モジュールスコープで定義 → 毎レンダーで同一参照を保証
const EMPTY_ARRAY: any[] = [];

const FilteredStrapiContext = createContext<any[]>(EMPTY_ARRAY);

const FilteredStrapiProvider: FC<{ children: ReactNode }> = ({ children }) => {
  // フィルタリング計算は結果ページ内の useAutoFilteredData に移行済み
  // Provider は後方互換のため空の context を提供
  return (
    <FilteredStrapiContext.Provider value={EMPTY_ARRAY}>
      {children}
    </FilteredStrapiContext.Provider>
  );
};

export function useFilteredStrapiContext() {
  return useContext(FilteredStrapiContext);
}

export default FilteredStrapiProvider;
